import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import Select, {components} from "react-select";
import UAvatar from "ubs-framework/v2/UAvatar";
import {useSelector} from "react-redux";
import useDebouncedEffect from "use-debounced-effect";
import {sendData} from "../../../store/actions";
import {getKeyName, getLabelValueUserImage, getThumbor} from "ubs-framework/v2/common/function";
import useSocket from "../hooks/useSocket";
import {LIMIT} from "ubs-framework/v2/common/constant";

const AsyncEmployeeSelect = React.memo((props) => {
    const _S3_BASE_URL = useSelector(e => e.common.S3_BASE_URL);
    const _S_ID = useSelector(e => e?.common?.socketId);
    const _ID = useSelector(e => e?.common?._id);
    const _AP = useSelector(e => e?.hrms?.allPayloads);

    const [search, setSearch] = useState('')
    const [user, setUser] = useState({})
    const [options, setOptions] = useState(props?.options?.length > 0 ? [...props?.options] : []);
    const handle = {
        change: (e) => {
            props?.onChange(e)
            setUser(e)
        }
    }

    useEffect(() => {
        return () => off();
    }, []);

    const {off, refresh} = useSocket(res => {
        if (!res.error && res?.data?.socketId === _S_ID) {
            switch (res.event) {
                case 'ats|candidate|search':{
                    setOptions(getLabelValueUserImage(res?.data?.list ?? []));
                    off()
                    break
                }
                case 'hrms|dropList|get':
                    if (res?.data?.listType === 4) {
                        if(props?.excludeClientName) {
                            res.data.rows = res?.data?.rows?.filter(item => item?._id !== _ID && item?._id !== _AP?._id);
                        }
                        setOptions(getLabelValueUserImage(res?.data?.rows));
                    }
                    off()
                    break
                default:
                    return true;
            }
        }
    });

    useDebouncedEffect(() => {
        if (search?.length >= LIMIT.SEARCH_CHARACTER) {
            if (props?.candidate) sendData('ats|candidate|search', {search, ...props?.requestData})
            else if (props?.level) sendData('hrms|dropList|get', {search, ...props?.requestData})
            else if(props?.evaluation) sendData('hrms|dropList|get', {listType: 4, search, ...props?.requestData})
            else sendData('hrms|dropList|get', {listType: 4, search, checkVisibility: props?.checkVisibility, ...props?.requestData})
            refresh();
        } else setOptions([]);
    }, LIMIT.DE_BOUNCING_TIME_OUT, [search]);

    const getProps = () => {
        if (props?.params?.isMulti) return {
            MultiValue: (props) => (
                <components.MultiValue  {...props} >
                    <div className="u_flex u_align-center">
                        <UAvatar name={props.data.label} width={24} image={props.data.profileImage} s3Url={_S3_BASE_URL} thumbor={getThumbor('32x32')}/>
                        <div>
                            <p className="u_one-line">{props.data.label}</p>
                            <p className="u_one-line u_font-12 u_color-light">{props.data.employeeId} </p>
                        </div>
                    </div>
                </components.MultiValue>
            ),
        }
        else return {
            SingleValue: (props) => (<components.SingleValue  {...props} >
                <div className="u_flex u_align-center">
                    <UAvatar name={props?.data?.label} width={24} thumbor={getThumbor('32x32')} image={props?.data?.profileImage} s3Url={_S3_BASE_URL}/>
                    <div>
                        <p className="u_one-line">{props?.data?.label}</p>
                        <p className="u_one-line u_font-12 u_color-light">{props?.data?.employeeId}</p>
                    </div>
                </div>
            </components.SingleValue>)
        }
    }
    return (
        <React.Fragment>
            <Select
                name="employee"
                isClearable={true}
                className={`u_input-select-inner ${props?.params?.isMulti ? 'u_multi-select-user' : 'u_single-select-user'} ${props?.className?.length ? props?.className : ''}`}
                classNamePrefix="u_select"
                placeholder={props?.placeholder ? props?.placeholder : " "}
                value={typeof props?.value === "string" ? (props?.options?.length ? (getKeyName(props?.options, props?.value) || user) : null) : props?.value}
                onInputChange={setSearch}
                onChange={handle.change}
                options={options}
                filterOption={option => option}
                maxMenuHeight={120}
                noOptionsMessage={() => search?.length < 3 ? `${props?.noOptionsMessage ? props?.noOptionsMessage : 'Type three character to search employee.'}` : 'No Record Found'}
                defaultOptions={options}
                menuPosition="fixed"
                menuIsOpen={props?.menuIsOpen}
                components={{
                    Option: (props) => (
                        <components.Option {...props} >
                            <div className="u_filter-employee-info">
                                <UAvatar name={props?.data?.label} width={24} thumbor={getThumbor('32x32')} image={props?.data?.profileImage} s3Url={_S3_BASE_URL}/>
                                <div>
                                    <p className="u_one-line">{props?.data?.label}</p>
                                     <p className="u_one-line u_font-12 u_color-light">{props?.data?.employeeId}</p>
                                </div>
                            </div>
                        </components.Option>
                    ),
                    ...getProps()
                }}
                {...props?.params}
            />
        </React.Fragment>
    );
});

AsyncEmployeeSelect.propTypes = {
    value: PropTypes.object,
    options: PropTypes.arrayOf(PropTypes.object),
    params: PropTypes.object,
    className: PropTypes.string,
    onChange: PropTypes.func,
    level: PropTypes.bool,
    requestData: PropTypes.object,
    disableIds: PropTypes.array,
    checkVisibility: PropTypes.bool,
};

AsyncEmployeeSelect.defaultProps = {
    value: null,
    params: {},
    options: [],
    className: '',
    level: false,
    candidate: false,
    requestData: {},
    onChange: () => {
    },
    disableIds:[],
    checkVisibility: true,
}

export default AsyncEmployeeSelect;
